import React, { useContext } from "react"
import Participant from "~/components/twilio/Participant"
import styled from "styled-components"
import { ParticipantsContext } from "~/components/twilio/ParticipantsProvider"
import { VideoContext } from "~/components/twilio/VideoProvider"

const ParticipantListContainer = styled.aside`
  & {
    overflow-y: auto;
    z-index: 5;
    &.transparentBackground {
      background: transparent;
    }
    padding: 20px 25px 0;
    ::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;

    @media screen and (max-width: 1185px) {
      height: auto;
      display: flex;
      justify-content: space-evenly;
      flex-wrap: wrap;
      padding: 10px 10px 0;
    }
  }
`

export default function ParticipantList() {
  const { participants } = useContext(ParticipantsContext)

  if (!participants || participants.length < 2) {
    return null
  }

  return (
    <ParticipantListContainer className="transparentBackground">
      {participants?.map((user) => {
        return <Participant key={user.userId} user={user} />
      })}
    </ParticipantListContainer>
  )
}
